import React from 'react';
import ReactEntry from "./ReactEntry"


const ReactEntryContainer = () => {
  return <ReactEntry />;
};

export default ReactEntryContainer;
